var axios = require("axios");

export const formInfo = async (content) => {
  const getNotNullValue = function (obj) {
    if ([undefined, null, "undefined", "null"].includes(obj)) {
      return "";
    }
    return obj;
  };

  let feishuData = {
    msg_type: "interactive",
    card: {
      header: {
        template: "yellow",
        title: {
          content: "📪 有官网表单提交，请及时联系~",
          tag: "plain_text",
        },
      },
      elements: [
        {
          fields: [
            {
              is_short: true,
              text: {
                content: "👤 ** 姓名：**" + getNotNullValue(content.name),
                tag: "lark_md",
              },
            },
            {
              is_short: true,
              text: {
                content: "🔈 **企业全称：**" + getNotNullValue(content.company),
                tag: "lark_md",
              },
            },
            {
              is_short: false,
              text: {
                content: "",
                tag: "lark_md",
              },
            },

            {
              is_short: true,
              text: {
                content:
                  "👤 **所属行业：**" + getNotNullValue(content.industry),
                tag: "lark_md",
              },
            },
            {
              is_short: true,
              text: {
                content: "🔈 **职务：**" + getNotNullValue(content.position),
                tag: "lark_md",
              },
            },

            {
              is_short: false,
              text: {
                content: "",
                tag: "lark_md",
              },
            },
            {
              is_short: true,
              text: {
                content: "📌 **联系电话：**" + getNotNullValue(content.phone),
                tag: "lark_md",
              },
            },
            {
              is_short: true,
              text: {
                content: "🗂️ **应用场景：**" + getNotNullValue(content.scene),
                tag: "lark_md",
              },
            },
          ],
          tag: "div",
        },
      ],
    },
  };
  const res = await axios.post(
    "https://open.feishu.cn/open-apis/bot/v2/hook/602b4e6c-f22d-4565-aae0-75255c31a0e5",
    feishuData
  );
  return res;
};
